import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ImageProvider } from './context/ImageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServiceBanner from './components/ServiceBanner';
import EventExperience from './components/EventExperience';
import MagnetGrid from './components/MagnetGrid';
import ShopCollection from './components/ShopCollection';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import AdminPortal from './components/AdminPortal';

const HomePage = () => (
  <div className="min-h-screen bg-parlor-cream font-sans text-parlor-green">
    <Navbar />
    <main>
      <Hero />
      <ServiceBanner />
      <EventExperience />
      <MagnetGrid />
      <ShopCollection />
      <Testimonials />
      <ContactForm />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <ImageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin-portal" element={<AdminPortal />} />
        </Routes>
      </Router>
    </ImageProvider>
  );
}

export default App;